import React, { useState } from "react";

import "./projects.css";
import ProjectList from "./ProjectList";
import ProjectList2 from "./ProjectList2";


const responsive = {
  desktop: {
    breakpoint: {
      max: 3000,
      min: 1024,
    },
    items: 3,  // Items shown on desktop
    partialVisibilityGutter: 30,
  },
  mobile: {
    breakpoint: {
      max: 550,
      min: 0,
    },
    items: 1,  // Items shown on mobile
    partialVisibilityGutter: 30,
  },
  tablet: {
    breakpoint: {
      max: 1024,
      min: 551,
    },
    items: 1.5,  // Items shown on tablet
    partialVisibilityGutter: 30,
  },
};


function Projects() {
  const [activeTab, setActiveTab] = useState("designProduct");

  return (
    <section className="MySkills" id="productcarousel">
      <div>
      
        
              {/* Tab buttons */}
              <div>
              <div className="tabs-contain">
              <button
                className={`tab-button ${activeTab === "designProduct" ? "active" : ""}`}
                onClick={() => setActiveTab("designProduct")}
              >
                Design
              </button>
              <button
                className={`tab-button ${activeTab === "developProduct" ? "active" : ""}`}
                onClick={() => setActiveTab("developProduct")}
              >
                Develop
              </button>
            </div>
           
           <div >
           <h2 className="aboutHeadingyyy">Recent Projects</h2>
           
           </div>
              </div>

            
           
         </div>
         <div>   

            <br />
          
        
       

      
          {/* Tab Content */}
          {activeTab === "designProduct" && <ProjectList responsive={responsive} />}
          {activeTab === "developProduct" && <ProjectList2 responsive={responsive} />}
      
      </div>
    </section>
  );
}

export default Projects;
